module.exports = __webpack_public_path__ + "media/img/video-play-53bb7d07.png";